import React, { useState, useEffect } from "react";

/** Components */
import { TableContainer, TableBody, Table, Paper, Checkbox, TableHead, TableRow, TableCell, TableFooter, TablePagination, ButtonGroup, Dialog, Tooltip } from "@mui/material";
import SelectStatusButton from "../../commons/SelectStatusButton";
import LoadingProgress from "../../commons/LoadingProgress.component";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";

/** Icons */
import RefreshIcon from "@mui/icons-material/Refresh";

/** Api && Function */
import { updateOrganizationStatus, getOrganizationData, postSync } from "./../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

/** Hook */

export default function Organization() {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const [orgData, setOrgData] = useState(undefined);
  const [changeIds, setChangeIds] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleCheckBoxClick = (id) => {
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };
  const handleRowClick = (e, row) => {
    if (e.target.type === "checkbox") return;
    setSelectedOrganization(row);
  };
  const handleUpdateStatus = (selectedStatus) => {
    return updateOrganizationStatus({ ids: changeIds, action: selectedStatus.action });
  };
  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      setOrgData((prev) => prev.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)));
    }
  };

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN CÔNG TY - CHI NHÁNH"));
    getOrganizationData().then((res) => {
      if (res.code === 200) {
        setOrgData(res.data);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div align="left">
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <ButtonWithAPICallComponent api={() => postSync({ object: "organization" })} variant="outlined">
            <Tooltip title="Lấy dữ liệu từ ERP">
              <RefreshIcon />
            </Tooltip>
          </ButtonWithAPICallComponent>
        </ButtonGroup>
      </div>
      {!orgData ? (
        <LoadingProgress />
      ) : (
        <React.Fragment>
          <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    ID
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t("Tên tổ chức")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t("Mã số")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t("Địa chỉ")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t("Số điện thoại")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t("Loại hình")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Trạng thái")}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>
                    <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orgData
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .sort((item1, item2) => item1.id - item2.id)
                  .map((row, index) => {
                    return (
                      <TableRow key={row.id} onClick={(e) => handleRowClick(e, row)} hover style={{ cursor: "pointer" }}>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {row.id}{" "}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                          {row.name}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {row.code}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {row.address}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {row.phone}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {row.type}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }}>{t(row.status)}</TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          <Checkbox disabled={row.status === "DELETED"} checked={changeIds.includes(row.id)} onClick={handleCheckBoxClick.bind(this, row.id)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    count={orgData?.length || 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
          <SelectDialog initialData={selectedOrganization} onClose={() => setSelectedOrganization(null)} />
        </React.Fragment>
      )}
    </div>
  );
}
const SelectDialog = ({ initialData, onClose }) => {
  const [t] = useTranslation();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Dialog open={Boolean(initialData)} onClose={onClose}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center">ID</TableCell>
              <TableCell align="center">{t("Tên người dùng")}</TableCell>
              <TableCell align="center">Email</TableCell>
              <TableCell align="center">{t("Tổ chức")}</TableCell>
              <TableCell align="center">{t("Tên nhóm")}</TableCell>
              <TableCell align="center">{t("Khách hàng")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {initialData?.user?.length ? (
              initialData?.user?.map((row) => (
                <TableRow>
                  <TableCell align="center">{row.id} </TableCell>
                  <TableCell align="center">{row.name}</TableCell>
                  <TableCell align="center">{row.email}</TableCell>
                  <TableCell align="center">{row.organization}</TableCell>
                  <TableCell align="center">{row.usergroup}</TableCell>
                  <TableCell align="center">{row.customer}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell align="center" colSpan={6}>
                  No data display
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                count={initialData?.user?.length || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </Dialog>
  );
};
